module.exports = __webpack_public_path__ + "static/img/ZHVBXKxw.e82b68f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/ZHVBXKxw.jpg
// module id = MU89
// module chunks = 7